import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../../Constant.js'
import axios from 'axios'

class AddProductImage extends React.Component {
  state = {
    isSaving: false,
    isData: false,
    Edit: false,
    image_path: '',
    img: '',
    vid: 'set',
    type: 'image',
  }

  componentDidMount() {
    if (this.props?.match?.params?.type) {
      this.setState({
        type: this.props.match.params.type,
      })
    }
  }

  handleChangeImage = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] })
    this.setState({ Edit: false })
    if (e.target.files[0]?.type?.startsWith('video/')) {
      Swal.fire('Invalid image file', '', 'error')
      this.setState({
        image_path: null,
      })
      return
    } else {
      this.setState({ img: URL.createObjectURL(e.target.files?.[0]) })
      this.setState({ vid: null })
    }
  }

  handleChangeVideo = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] })
    this.setState({ Edit: false })
    if (e.target.files[0]?.type?.startsWith('image/')) {
      Swal.fire('Invalid video file', '', 'error')
      this.setState({
        image_path: null,
      })
      return
    } else {
      this.setState({ vid: URL.createObjectURL(e.target.files?.[0]) })
      this.setState({ img: null })
    }
  }
  onSaveData = () => {
    const formData = new FormData()
    var productId = this.props.match.params.productId
    formData.append('product_id', productId)
    formData.append('image_path', this.state.image_path)
    this.setState({ isData: true })
    axios
      .post(Constant.getAPI() + '/store/add-store-product-image', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        this.setState({ isData: false })
        if (res.status) {
          Swal.fire({
            title: 'Product Image Added Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
        window.location.href = `#/storeProductsImage/${this.props.match.params.productId}`
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>Product Image Add</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>

                    <li className="breadcrumb-item active">Product Image add</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="row">
                              <div className="col-sm-3"> {this.state.type === 'video' ? 'Video(MP4)' : 'Image'}</div>
                              <div className="col-sm-9">
                                <div className="form-group">
                                  <div>
                                    {this.state.type === 'image' ? (
                                      <input
                                        type="file"
                                        id="img"
                                        name="image_path"
                                        accept="image/*"
                                        className="w-100"
                                        onChange={this.handleChangeImage}
                                      />
                                    ) : (
                                      <input
                                        type="file"
                                        id="img"
                                        name="image_path"
                                        accept=".mp4"
                                        className="w-100"
                                        onChange={this.handleChangeVideo}
                                      />
                                    )}
                                  </div>
                                </div>
                                {this.state.Edit ? (
                                  <div>
                                    {this.state.image_path?.indexOf('/public') !== -1 ? (
                                      <div>
                                        {this.state.image_path?.indexOf('.mp4') !== -1 ? (
                                          <video
                                            width="250"
                                            controls
                                          >
                                            <source
                                              src={
                                                this.state.image_path !== undefined &&
                                                this.state.image_path !== null &&
                                                this.state.image_path !== ''
                                                  ? Constant.getImage() + this.state.image_path
                                                  : './assets/images/icon.png'
                                              }
                                              type="video/mp4"
                                            />
                                          </video>
                                        ) : (
                                          <img
                                            width="250px"
                                            height="200px"
                                            src={
                                              this.state.image_path !== undefined &&
                                              this.state.image_path !== null &&
                                              this.state.image_path !== ''
                                                ? Constant.getImage() + this.state.image_path
                                                : './assets/images/icon.png'
                                            }
                                            alt="tbl"
                                          />
                                        )}
                                      </div>
                                    ) : null}
                                  </div>
                                ) : (
                                  <div>
                                    {this.state.vid !== 'set' ? (
                                      <div>
                                        {this.state.vid !== null ? (
                                          <video
                                            width="250"
                                            controls
                                          >
                                            <source
                                              src={
                                                this.state.vid !== undefined &&
                                                this.state.vid !== null &&
                                                this.state.vid !== ''
                                                  ? this.state.vid
                                                  : './assets/images/icon.png'
                                              }
                                              type="video/mp4"
                                            />
                                          </video>
                                        ) : (
                                          <img
                                            width="250px"
                                            height="400px"
                                            src={
                                              this.state.img !== undefined &&
                                              this.state.img !== null &&
                                              this.state.img !== ''
                                                ? this.state.img
                                                : './assets/images/icon.png'
                                            }
                                            alt="img"
                                          />
                                        )}
                                      </div>
                                    ) : null}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-footer">
                          <div className="row">
                            <div className="text-right col-6 offset-6">
                              <Link
                                to={`/storeProductsImage/${this.props.match.params.productId}`}
                                className="btn btn-outline-secondary m-2 "
                              >
                                <i className="icofont icofont-rounded-double-left"></i>
                                Back
                              </Link>
                              {this.state.isData ? (
                                <button
                                  className="btn btn-grd-disabled mr-2"
                                  disabled
                                >
                                  Saving...!
                                </button>
                              ) : (
                                <button
                                  onClick={this.onSaveData}
                                  className="btn hor-grd btn-grd-inverse offset-1"
                                >
                                  <i className="ti-save"></i>Save
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AddProductImage
